module.exports = __webpack_public_path__ + "img/home-dot-gc.cd2d42af.png";